import {ApiClient} from '@hconnect/apiclient'
import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useMutation} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

export type ResponseType = {
  data: string
}

export const useRequestAccess = (analysisId: string, successCb?: () => void) => {
  const {t} = useTranslation()

  return useMutation({
    mutationFn: async () => {
      const path = `/rootcausefailureanalysis/analyses/${analysisId}/access`
      return (await ApiClient.axiosInstance.post<ResponseType>(path)).data
    },
    onSuccess: () => {
      spawnSuccessToast(t('privateAnalysis.successMessage'), {closeOnClick: true})
      successCb?.()
    },
    onError: () => spawnErrorToast('Failed to request access', {closeOnClick: true})
  })
}
